module.exports = __webpack_public_path__ + "static/fabric-datepicker-required-211d6b8063815499d01f416b53d0a5ef.png";